<form [ngClass]="{'pending': pending === true}" [formGroup]="form" (submit)="submit()">
  <label>Connexion via SMS</label>

  <small class="alert-danger p-4 mb-2" *ngIf="error">
    {{error.message}}
  </small>

  <div *ngIf="!captchaSolved">
    <div class="p-4" style="background-color: #f6f6f6">
      <spaq-input-sms [form]="form"></spaq-input-sms>
      <spaq-input-captcha [form]="form"></spaq-input-captcha>

      <button id="captcha" [primary]="true" kendoButton class="w-100 mt-4" type="submit">Continuer</button>
      <button [primary]="false" kendoButton class="w-100 mt-4" routerLink="/auth/register/choose" type="button">Inscription
      </button>
    </div>
  </div>
  <div *ngIf="captchaSolved">
    <div *ngIf="!(error && error.code == 'auth/code-expired')" class="p-4" style="background-color: #f6f6f6">
      <div [hidden]="">
        <p>Dans quelques minutes vous recevrez un code par SMS. Inscrivez ce code dans le champ ci-dessous pour vous
          identifier.</p>
        <spaq-input-text [form]="form" label="Code de confirmation" name="code"></spaq-input-text>
      </div>

      <button [primary]="true" kendoButton class="w-100 mt-4" type="submit">Continuer</button>

    </div>
    <div *ngIf="error && error.code == 'auth/code-expired'" class="p-0">

      <button [primary]="true" kendoButton class="w-100 mt-4" (click)="reset()" type="button">Recommencer</button>

    </div>

  </div>
</form>



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/login/components/login-sms/login-sms.component.html